import React, { Component } from 'react'
import {
    Form,
    Card,
    Button,
    Input,
    Upload,
    Image,
    Divider,
    Table,
    Popconfirm,
    message
} from 'antd'
import { CirclePicker } from 'react-color'
import { cloneDeep } from 'lodash'
import styled from 'styled-components'
import {
    VerticalAlignBottomOutlined,
    EditTwoTone,
    DeleteOutlined,
    DeleteTwoTone,
    PlusOutlined,
    CheckCircleTwoTone,
    CloseCircleTwoTone,
    UploadOutlined
} from '@ant-design/icons'
import {
    getFooterConfig,
    setFooterConfig,
    uploadImage
} from '../../services/apiServices'
import RowLayout from '../../commons/RowLayout/RowLayout'
import LoadingModal from '../../commons/Modal/Loading'
import SaveButton from './../../commons/Button/SaveButton'
import ColorSelector from './../../commons/ColorSelector/ColorSelector'

import ContactModal from './ContactModal'
import SubmenuModal from './SubmenuModal'

const COLOR_LIST = [
    '#e74c3c',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffcc00',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#2c3e50'
]

const Container = styled(Card)`
    .image-wrapper {
        display: inline-block;
        padding: 20px;
        margin-top: 15px;
        border: 1px dashed #ccc;
        > img {
            max-width: 400px;
        }
    }
    .footer-image-wrapper {
        cursor: pointer;
        display: flex;
        max-width: 500px;
        margin-bottom: 15px;
        &:hover {
            opacity: 0.8;
        }
        &.selected {
            border: 3px solid #1890ff !important;
        }

        img {
            width: 100%;
        }
    }
    .radio-y {
        display: block;
        height: 30px;
        line-height: 30px;
    }
`

const FOOTER_STYLES = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }]

class Footer extends Component {
    state = {
        isLoading: false,
        footerStyle: 1,
        backgroundColor: '',
        paymentImage: '',
        description: '',
        contacts: [],
        menus: [],
        isOpenContactModal: false,
        selectedContactIndex: -1,
        selectedContactInfo: {},
        isOpenMenuModal: false,
        selectedMenuGroupIndex: -1,
        selectedMenuIndex: -1,
        selectedMenuInfo: {}
    }

    formRef = React.createRef()

    componentDidMount() {
        this.getFooterConfig()
    }

    onFinish(values) {
        let data = {
            style: this.state.footerStyle,
            description: values.description,
            copyright_text: values.copyrightText,
            background_color: this.state.backgroundColor,
            contacts: this.state.contacts,
            menus: this.state.menus,
            payment_image: this.state.paymentImage
        }
        this.setFooterConfig(data)
    }

    async getFooterConfig() {
        this.setState({ isLoading: true })
        try {
            let footerConfig = await getFooterConfig()
            this.setState({
                isLoading: false,
                footerStyle: footerConfig.style,
                backgroundColor: footerConfig.background_color,
                paymentImage: footerConfig.payment_image,
                copyrightText: footerConfig.copyright_text,
                contacts: footerConfig.contacts || [],
                menus: footerConfig.menus || []
            })

            this.formRef.current &&
                this.formRef.current.setFieldsValue({
                    description: footerConfig.description,
                    copyrightText: footerConfig.copyright_text
                })
        } catch (error) {
            console.log(error)
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async setFooterConfig(data) {
        this.setState({ isLoading: true })
        try {
            await setFooterConfig({
                body: { config: data }
            })
            this.setState({
                isLoading: false
            })
            message.success(this.props.T('SAVED'))
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async uploadImage(file, onSuccess) {
        this.setState({ isLoading: true })
        try {
            let { image } = await uploadImage({ body: { file } })
            this.setState({ isLoading: false })
            onSuccess && onSuccess(image)
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    onChangeStyle(style) {
        this.setState({ footerStyle: style })
    }

    onChangeColor = color => {
        this.setState({ backgroundColor: color })
    }

    onChangePaymentImage(e) {
        this.uploadImage(e.file.originFileObj, image =>
            this.setState({ paymentImage: image })
        )
    }

    onRemovePaymentImage() {
        this.setState({ paymentImage: '' })
    }

    toggleContactModal(status, onSuccess) {
        this.setState(
            {
                isOpenContactModal: status
            },
            () => {
                onSuccess && onSuccess()
            }
        )
    }

    onOpenEditCantact(index = -1) {
        let state = {
            isOpenContactModal: true,
            selectedContactIndex: index,
            selectedContactInfo: {}
        }
        if (index != -1) {
            state.selectedContactInfo = this.state.contacts[index]
        }
        this.setState(state)
    }

    onSaveEditContact(info = {}) {
        console.log(info)
        let index = this.state.selectedContactIndex
        let contacts = cloneDeep(this.state.contacts)
        if (index != -1) {
            contacts[index] = info
        } else {
            contacts.push(info)
        }
        this.setState({
            isOpenContactModal: false,
            selectedContactIndex: -1,
            selectedContactInfo: {},
            contacts
        })
    }

    onRemoveCantact(index = 0) {
        let contacts = cloneDeep(this.state.contacts)
        contacts.splice(index, 1)
        this.setState({ contacts })
    }

    toggleMenuModal(status, onSuccess) {
        this.setState(
            {
                isOpenMenuModal: status
            },
            () => {
                onSuccess && onSuccess()
            }
        )
    }

    onOpenEditMenu(groupIndex = 0, index = -1) {
        let state = {
            isOpenMenuModal: true,
            selectedMenuGroupIndex: groupIndex,
            selectedMenuIndex: index,
            selectedMenuInfo: {}
        }
        if (index != -1) {
            state.selectedMenuInfo =
                this.state.menus[groupIndex].submenus[index]
        }
        this.setState(state)
    }

    onSaveEditMenu(info = {}) {
        console.log(info)
        let groupIndex = this.state.selectedMenuGroupIndex
        let index = this.state.selectedMenuIndex
        let menus = cloneDeep(this.state.menus)
        if (index != -1) {
            menus[groupIndex].submenus[index] = info
        } else {
            menus[groupIndex].submenus.push(info)
        }
        this.setState({
            isOpenMenuModal: false,
            selectedMenuGroupIndex: 0,
            selectedMenuIndex: -1,
            selectedMenuInfo: {},
            menus
        })
    }

    onRemoveMenu(groupIndex = 0, index = 0) {
        let menus = cloneDeep(this.state.menus)
        menus[groupIndex].submenus.splice(index, 1)
        this.setState({ menus })
    }

    onAddMenuGroup() {
        let menus = cloneDeep(this.state.menus)
        menus.push({
            title: '',
            submenus: []
        })
        this.setState({ menus })
    }

    onRemoveMenuGroup(groupIndex = 0) {
        let menus = cloneDeep(this.state.menus)
        menus.splice(groupIndex, 1)
        this.setState({ menus })
    }

    onChangeMenuGroupTitle(groupIndex = 0, title = '') {
        let menus = cloneDeep(this.state.menus)
        menus[groupIndex].title = title
        this.setState({ menus })
    }

    render() {
        let { T } = this.props

        return (
            <Form ref={this.formRef} onFinish={this.onFinish.bind(this)}>
                <Container
                    title={
                        <span className="text-xl">
                            <VerticalAlignBottomOutlined /> {T('FOOTER')}
                        </span>
                    }>
                    <RowLayout title={T('STYLE')}>
                        {FOOTER_STYLES.map(footer => (
                            <div
                                className={`footer-image-wrapper ${
                                    footer.id == this.state.footerStyle
                                        ? 'selected'
                                        : ''
                                }`}
                                style={{
                                    border: '2px solid #ddd'
                                }}
                                key={footer.id}
                                onClick={() => this.onChangeStyle(footer.id)}>
                                <img
                                    src={`${window.config.themeUrl}/manager/static/images/layout-footer/${footer.id}.jpg`}
                                />
                            </div>
                        ))}
                    </RowLayout>

                    <Divider />

                    <RowLayout title={T('BACKGROUND_COLOR')}>
                        <div style={{ marginBottom: 15 }}>
                            <CirclePicker
                                width={400}
                                color={this.state.backgroundColor}
                                colors={COLOR_LIST}
                                onChange={color =>
                                    this.onChangeColor(color.hex)
                                }
                            />
                        </div>
                        <div>
                            <div style={{ marginBottom: 10 }}>{T('OR')}</div>
                            <ColorSelector
                                disableRemoveIcon
                                color={this.state.backgroundColor}
                                onChange={this.onChangeColor.bind(this)}
                            />
                        </div>
                    </RowLayout>

                    <Divider />

                    <RowLayout title={T('DESCRIPTION')}>
                        <Form.Item name="description">
                            <Input.TextArea
                                autoSize={{ minRows: 3 }}
                                placeholder={T('SUPPORT_SHORTCODE')}
                            />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('FOOTER_CONTACT')}>
                        <ContactList
                            T={T}
                            contacts={this.state.contacts}
                            onOpenEdit={this.onOpenEditCantact.bind(this)}
                            onRemove={this.onRemoveCantact.bind(this)}
                        />
                    </RowLayout>

                    <Divider />

                    <RowLayout title={T('MENU_GROUP')}>
                        {this.state.menus.map((menu, groupIndex) => (
                            <SubmenuList
                                key={menu.title || groupIndex}
                                T={T}
                                title={menu.title}
                                menus={menu.submenus}
                                onOpenEdit={index =>
                                    this.onOpenEditMenu(groupIndex, index)
                                }
                                onRemove={index =>
                                    this.onRemoveMenu(groupIndex, index)
                                }
                                onRemoveGroup={() =>
                                    this.onRemoveMenuGroup(groupIndex)
                                }
                                onChangeGroupTitle={title =>
                                    this.onChangeMenuGroupTitle(
                                        groupIndex,
                                        title
                                    )
                                }
                            />
                        ))}
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => this.onAddMenuGroup()}>
                            {T('ADD_MENU_GROUP')}
                        </Button>
                    </RowLayout>

                    <Divider />

                    <RowLayout title={T('COPYRIGHT_TEXT')}>
                        <Form.Item name="copyrightText">
                            <Input placeholder="Copyright © [current_year], All Rights Reserved" />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('PAYMENT_IMAGE')}>
                        <Form.Item>
                            <div>
                                <div
                                    style={{
                                        display: 'inline-block',
                                        marginRight: 10
                                    }}>
                                    <Upload
                                        accept="image/gif, image/jpeg, image/png, image/webp"
                                        fileList={[]}
                                        customRequest={() => {}}
                                        onChange={this.onChangePaymentImage.bind(
                                            this
                                        )}>
                                        <Button
                                            type="primary"
                                            icon={<UploadOutlined />}>
                                            {T('UPLOAD')}
                                        </Button>
                                    </Upload>
                                </div>
                                {this.state.paymentImage && (
                                    <Button
                                        type="primary"
                                        danger
                                        style={{
                                            display: 'inline-block',
                                            marginRight: 5
                                        }}
                                        icon={<DeleteOutlined />}
                                        onClick={() =>
                                            this.onRemovePaymentImage()
                                        }>
                                        {T('REMOVE')}
                                    </Button>
                                )}
                            </div>
                            {this.state.paymentImage && (
                                <div className="image-wrapper">
                                    <Image
                                        key={this.state.paymentImage}
                                        src={this.state.paymentImage}
                                    />
                                </div>
                            )}
                        </Form.Item>
                    </RowLayout>

                    <ContactModal
                        T={T}
                        info={this.state.selectedContactInfo}
                        isOpen={this.state.isOpenContactModal}
                        onCancel={() => this.toggleContactModal(false)}
                        onOk={this.onSaveEditContact.bind(this)}
                    />

                    <SubmenuModal
                        T={T}
                        info={this.state.selectedMenuInfo}
                        isOpen={this.state.isOpenMenuModal}
                        onCancel={() => this.toggleMenuModal(false)}
                        onOk={this.onSaveEditMenu.bind(this)}
                    />

                    <LoadingModal isOpen={this.state.isLoading} />
                </Container>
                <SaveButton T={T} />
            </Form>
        )
    }
}

const ContactList = ({ T, contacts = [], onOpenEdit, onRemove }) => (
    <Card
        type="inner"
        size="small"
        extra={
            <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => onOpenEdit(-1)}>
                {T('ADD')}
            </Button>
        }
        style={{ marginBottom: 24 }}>
        <Table
            pagination={false}
            dataSource={contacts}
            rowKey={(record, index) => index}
            columns={[
                {
                    title: T('ICON'),
                    dataIndex: 'icon',
                    key: 'icon',
                    align: 'center',
                    render: (el, record) =>
                        record.icon ? (
                            <i className={`icon-${record.icon}`}></i>
                        ) : (
                            '-'
                        )
                },
                {
                    title: T('TEXT'),
                    dataIndex: 'text',
                    key: 'text'
                },
                {
                    dataIndex: 'action',
                    key: 'action',
                    render: (el, record, index) => (
                        <>
                            <Button
                                style={{
                                    marginRight: 5
                                }}
                                type="text"
                                shape="circle"
                                icon={<EditTwoTone />}
                                size="small"
                                onClick={() => onOpenEdit(index)}
                            />
                            <Popconfirm
                                placement="top"
                                title={T('CONFIRM_REMOVE_MENU_MSG')}
                                onConfirm={() => onRemove(index)}
                                okText={T('YES')}
                                cancelText={T('NO')}>
                                <Button
                                    danger
                                    type="text"
                                    shape="circle"
                                    icon={
                                        <DeleteTwoTone twoToneColor="#ff4d4f" />
                                    }
                                    size="small"
                                />
                            </Popconfirm>
                        </>
                    )
                }
            ]}
        />
    </Card>
)

const SubmenuList = ({
    T,
    title = '',
    menus = [],
    onOpenEdit,
    onRemove,
    onRemoveGroup,
    onChangeGroupTitle
}) => (
    <Card
        title={
            <Input
                placeholder={T('TITLE')}
                style={{ width: 150 }}
                defaultValue={title}
                onBlur={e => onChangeGroupTitle(e.target.value)}
            />
        }
        type="inner"
        size="small"
        extra={
            <>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    style={{
                        marginRight: 5
                    }}
                    onClick={() => onOpenEdit(-1)}>
                    {T('ADD')}
                </Button>
                <Popconfirm
                    placement="top"
                    title={T('CONFIRM_REMOVE_MENU_GROUP_MSG')}
                    onConfirm={() => onRemoveGroup()}
                    okText={T('YES')}
                    cancelText={T('NO')}>
                    <Button type="primary" danger icon={<DeleteOutlined />}>
                        {T('REMOVE')}
                    </Button>
                </Popconfirm>
            </>
        }
        style={{ marginBottom: 24 }}>
        <Table
            pagination={false}
            dataSource={menus}
            rowKey={(record, index) => index}
            columns={[
                {
                    title: T('TEXT'),
                    dataIndex: 'title',
                    key: 'title'
                },
                {
                    title: T('URL'),
                    dataIndex: 'url',
                    key: 'url'
                },
                {
                    title: T('OPEN_NEW_TAB'),
                    dataIndex: 'isNewTab',
                    key: 'isNewTab',
                    align: 'center',
                    render: (el, record) =>
                        record.is_new_tab ? (
                            <CheckCircleTwoTone twoToneColor="#52c41a" />
                        ) : (
                            <CloseCircleTwoTone twoToneColor="#aaaaaa" />
                        )
                },
                {
                    dataIndex: 'action',
                    key: 'action',
                    render: (el, record, index) => (
                        <>
                            <Button
                                style={{
                                    marginRight: 5
                                }}
                                type="text"
                                shape="circle"
                                icon={<EditTwoTone />}
                                size="small"
                                onClick={() => onOpenEdit(index)}
                            />
                            <Popconfirm
                                placement="top"
                                title={T('CONFIRM_REMOVE_MENU_MSG')}
                                onConfirm={() => onRemove(index)}
                                okText={T('YES')}
                                cancelText={T('NO')}>
                                <Button
                                    danger
                                    type="text"
                                    shape="circle"
                                    icon={
                                        <DeleteTwoTone twoToneColor="#ff4d4f" />
                                    }
                                    size="small"
                                />
                            </Popconfirm>
                        </>
                    )
                }
            ]}
        />
    </Card>
)

export default Footer
